import {useQuery} from '@tanstack/react-query';
import {UserApi, UserMapper} from 'app/components/entities/user';

export function useProfileQuery(teamId: string) {
  return useQuery({
    queryKey: ['profile'],
    queryFn: async () => {
      const response = await UserApi.getTeamProfile(teamId);
      return UserMapper.mapProfile(response);
    },
  });
}
